import { AutogenLayoutProspectConversionRateReport } from './autogen/AutogenLayoutProspectConversionRateReport';
import { LookupModelSearchEvent } from '@mcleod/components';

/**
 * Prospect Conversion Rate Report - Web Implementation
 * PBI: 352179
 *
 * Displays prospect conversion metrics including conversion dates, elapsed days,
 * and activity counts. Supports grouping by operations user, sales manager, or
 * salesperson with dynamic page break functionality.
 */
export class ProspectConversionRateReport extends AutogenLayoutProspectConversionRateReport {

    onLoad(): void {
        // Set default values using display values (framework will map to DB codes)
        this.textboxGroupBy.setSelectedItemFromValue("A");
        this.textboxSortBy.setSelectedItemFromValue("C");
        
        // Initialize include switch to Customers Only (unchecked/left position)
        this.switchInclude.checked = false;
    }

    /**
     * Handles changes to the Include switch.
     * Updates the customer field caption and lookup model based on selection.
     */
    includeChanged() {
        // When checked (right position) = Customers and Prospects, When unchecked (left position) = Customers Only
        const isCustomersAndProspects = this.switchInclude.checked;
        
        if (isCustomersAndProspects) {
            // Customers and Prospects
            this.excludabletextboxCustomers.textbox.caption = "Customer(s) / Prospect(s)";
            this.excludabletextboxCustomers.textbox.lookupModel = "lme/crm/prospect";
            this.excludabletextboxCustomers.textbox.lookupModelLayout = "lme/crm/ProspectLookup";
        } else {
            // Customers Only
            this.excludabletextboxCustomers.textbox.caption = "Customer(s)";
            this.excludabletextboxCustomers.textbox.lookupModel = "lme/ar/customer";
            this.excludabletextboxCustomers.textbox.lookupModelLayout = "lme/ar/CustomerLookup";
        }
        
        // Clear the field when switching modes
        this.excludabletextboxCustomers.textbox.clear();
    }

    excludabletextboxOperationsUserBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        // Filter to only show User ('U') or Employee ('E') web user types
        event.filter.web_user_type = "U || E";
    }

    textboxGroupByAfterDropdownSelection() {
        if (this.textboxGroupBy.text === "None") {
            this.checkboxPageBreak.enabled = false;
            this.checkboxPageBreak.checked = false;
        } else {
            this.checkboxPageBreak.enabled = true;
        }
    }
}
